export default {
    path: '/engagement/:workforce/:board/:url',
    name: 'engagement-form',
    component: () => import('source/pages/concerns/CommandBoardEngagementForm.vue'),
    meta: {
        title: 'Engagement Form - HQZen',
        loginRequired: false,
    },
};
